import { createFileRoute, Outlet } from "@tanstack/react-router"
import { RoleGate } from "@/components/role-gate"
import { needsCandidateOnboarding } from "@/lib/candidate"

export const Route = createFileRoute("/candidate")({
  component: SeekerLayout,
})

function SeekerLayout() {
  return (
    <RoleGate
      role="seeker"
      isDeskPath={(pathname) => pathname.startsWith("/candidate")}
      onWrongRole={(navigate) => void navigate({ to: "/recruit" })}
      onReady={(profile, pathname, navigate) => {
        if (needsCandidateOnboarding(profile)) {
          void navigate({
            to: "/onboarding/candidate",
            search: { returnTo: pathname },
          })
        }
      }}
    >
      <Outlet />
    </RoleGate>
  )
}
